export default __webpack_public_path__ + "static/media/video2.5e4287cd.png";